import React, { Component } from "react";
import axios from "../../configAxios";
import dateFns from "date-fns";
import FormButton from "../UI/button/FormButton";
import DatePicker from "../UI/datePicker/index";
import Spinner from "../UI/Spinner";

class GrantApplication extends Component {
  constructor() {
    super();
    const currentMonthDate = new Date();
    this.signal = axios.CancelToken.source();
    this.state = {
      startDate: new Date().setMonth(currentMonthDate.getMonth() - 1),
      endDate: new Date(),
      grantApplication: {},
      metaData: {},
      loading: true,
      disabled: true
    };
  }

  componentDidMount() {
    const queryParams = {
      id: "GrantApplicationReport"
    };
    this.getGrantApplicationData(queryParams);
  }

  componentWillUnmount() {
    this.signal.cancel('Request is being Cancelled');
  }

  getGrantApplicationData(queryParams) {
    axios.get("/reports/grant_application", { params: queryParams, cancelToken: this.signal.token })
      .then(res => {
        this.setState({
          grantApplication: res.data.json,
          loading: false,
          disabled: false
        });
      });
  }

  submitHandler = event => {
    event.preventDefault();
    this.setState({ loading: true, disabled: true });
    const { startDate, endDate } = this.state;
    const report_options = {
      start: {
        year: dateFns.format(startDate, "YYYY"),
        month: dateFns.format(startDate, "MM"),
        day: dateFns.format(startDate, "DD")
      },
      end: {
        year: dateFns.format(endDate, "YYYY"),
        month: dateFns.format(endDate, "MM"),
        day: dateFns.format(endDate, "DD")
      }
    };
    const queryParams = {
      id: "GrantApplicationReport",
      report_options
    };
    this.getGrantApplicationData(queryParams);
  };

  render() {
    const { grantApplication } = this.state;

    return (
      <div className="container service-kind w-100">
        <div className="row mb-4">
          <div className="col-12">
            <h3>Grant Application Report</h3>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body">
                <div className="card-text">
                  <form onSubmit={this.submitHandler}>
                    <div className="row">
                      <div className="col-3">
                        <label>From</label>
                        <DatePicker
                          dateFormat={"yyyy-MM-dd"}
                          selected={this.state.startDate}
                          changed={date => this.setState({ startDate: date })}
                        />
                      </div>
                      <div className="col-3">
                        <label>To</label>
                        <DatePicker
                          dateFormat={"yyyy-MM-dd"}
                          selected={this.state.endDate}
                          changed={date => this.setState({ endDate: date })}
                        />
                      </div>
                      <div className="col-3">
                        <FormButton className="build-report" disabled={this.state.disabled}>Build Report</FormButton>
                      </div>
                    </div>
                  </form>
                  <div className="row mt-5">
                    <div className="col-12">
                      <h5 className="font-weight-bold">
                        Statistics
                      </h5>
                    </div>
                  </div>
                  {
                    this.state.loading ? (
                      <div className="row">
                        <div className="col-12">
                          <Spinner className="h-30vh" />
                        </div>
                      </div>
                    ) : (
                        <div className="row">
                          <div className="col-6">
                            <p>Number of Volunteers for the Period </p>
                            <p>Total Volunteer Hours for the Period </p>
                            <p> Number of Active Members for the Period</p>
                            <p>{`${
                              grantApplication.organization_credit_name
                              } earned for the period `}</p>
                            <p>{`${
                              grantApplication.organization_credit_name
                              } used for the period `}</p>
                            <p>Employee Grants used for the Period</p>
                          </div>
                          <div className="col-6">
                            <p>
                              {this.state.loading
                                ? 0
                                : grantApplication.data.num_volunteers}
                            </p>
                            <p>
                              {this.state.loading
                                ? 0
                                : grantApplication.data.volunteer_hours}
                            </p>
                            <p>
                              {this.state.loading
                                ? 0
                                : grantApplication.data.num_active_members}
                            </p>
                            <p>
                              {this.state.loading
                                ? 0
                                : grantApplication.organization_credits_earned_currency}
                            </p>
                            <p>
                              {this.state.loading
                                ? 0
                                : grantApplication.organization_credit_name_value}
                            </p>
                            <p>
                              {this.state.loading
                                ? 0
                                : grantApplication.employee_grants_used}
                            </p>
                          </div>
                        </div>
                      )
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default GrantApplication;
